import type { FreelancerResetPasswordLocales } from '../types';

const freelancerResetPasswordLocales: FreelancerResetPasswordLocales = {
  enterNewPassword:
    'Stel hier je nieuwe wachtwoord in. Zorg er voor dat je hem onthoud deze keer ;)',
  passwordForgotten: 'Wachtwoord Vergeten',
  repeatPassword: 'herhaal wachtwoord',
  resetPassword: 'Wachtwoord Resetten',
  title: 'Wachtwoord opnieuw instellen',
};

export default freelancerResetPasswordLocales;
